import {
  buildService,
  ServiceError,
  createApplicationErrorCodes
} from './index';

export enum simulatorModeTypes {
  RANDOM = 'random',
  QUESTIONS = 'questions',
  DENIAL_TRANSACTION = 'denial_cumulative_transaction_activity_amount',
  DENIAL_DECEASED = 'denial_individual_reported_dead',
  FAILED_QUESTIONS = 'failed_iauth_questions',
  INDIVIDUAL_NOT_FOUND = 'individual_not_found',
  PASSED = 'passed',
  DENY = 'denial',
  FAILED_ICHECK = 'failed_icheck',
  DENIAL_AGE = 'denial_age_verification_mismatch',
  DENIAL_ADDRESS = 'denial_address_warning',
  FAIL_AGE = 'age_under_threshold',
  DENIAL_NOT_CURRENT_ADDRESS = 'denial_currentaddress_notcurrent',
  DENIAL_NOT_FOUND_ADDRESS = 'denial_currentaddress_notfound',
  DENIAL_DRIVERS_LICENSE = 'denial_driverslicense_undiscovered_failure',
  DENIAL_RISK = 'denial_risk',
  DENIAL_INFO_MISMATCH = 'denial_ssn_dob_mismatch',
  DENIAL_SSN_VIOLATION = 'denial_ssn_match_violation',
  DENIAL_MISSING_SSN = 'denial_ssn_not_provided'
}

interface EVerifyResponse {
  uberId: string;
  userId: string;
  trackingid: string;
  token: string;
}

interface EVerifyArgs {
  applicationID: string;
  verificationRequestAddress: {
    street: string;
    city: string;
    stateCode: string;
    zipCode: string;
  };
  verificationRequestCustomer: {
    firstName: string;
    middleName: string | undefined;
    lastName: string;
    dateOfBirth: string;
    taxID: string;
  };
  simulatorModeType?: simulatorModeTypes;
}

export const handleNotificationBadRequestError = (
  error: any,
  payload: any
): any => {
  const is400BadRequest: boolean =
    error?.status === 400 ||
    error?.response?.status === 400 ||
    error?.message?.includes('NetworkError');

  if (is400BadRequest) return { serviceErrorCode: 400 };

  throw new ServiceError(
    `A service call has failed with status: ${error} (payload: ${JSON.stringify(
      payload
    )})`
  );
};

const EVerifyRequestService = buildService('/nasu-svc/service/everify-request');
const EVerifyNotificationService = buildService(
  '/nasu-svc/service/everify-notification/'
);
export const postEVerifyRequest = (
  payload: EVerifyArgs
): Promise<EVerifyResponse> => {
  return EVerifyRequestService.add(payload);
};

export const postEverifyNotification = (token: string): Promise<any> => {
  return EVerifyNotificationService.http.postWithoutPayload(token, {
    createApplicationErrorCodes,
    handleServiceResponse: handleNotificationBadRequestError
  });
};
